import __var_0__ from './factory.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var factory = __var_0__;


// MAIN //

/**
* Returns a pseudorandom number drawn from an exponential distribution with parameter `lambda`.
*
* @name exponential
* @type {PRNG}
* @param {PositiveNumber} lambda - rate parameter
* @returns {NonNegativeNumber} pseudorandom number
*
* @example
* var v = exponential( 4.8 );
* // returns <number>
*
* @example
* var v = exponential( 0.0 );
* // returns NaN
*
* @example
* var v = exponential( NaN );
* // returns NaN
*/
var exponential = factory();


// EXPORTS //
export default exponential;
